import React from "react";

export function GobbyTable({ children, striped = true, compact, className }) {
    const tableClasses = `table ${striped ? 'table--striped' : ''} ${compact ? 'table--compact' : ''} ${className || ''}`;
    return (
        <div className="table-container">
            <table className={tableClasses.trim()}>
                {children}
            </table>
        </div>
    );
}

export function GobbyTableHead({ children }) {
    return <thead>{children}</thead>;
}

export function GobbyTableBody({ children, ...props }) {
    return <tbody {...props}>{children}</tbody>;
}

export function GobbyTableRow({ children, ...props }) {
    return <tr {...props}>{children}</tr>;
}

export function GobbyTableHeader({ children, className, ...props }) {
    return <th className={className} {...props}>{children}</th>;
}

export const GobbyTableCell = React.forwardRef(({ children, rowSpan, className, ...props }, ref) => {
    return <td ref={ref} rowSpan={rowSpan} className={className} {...props}>{children}</td>;
});
GobbyTableCell.displayName = 'GobbyTableCell';
